var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafetyblack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 82,
    viewBox: "0 0 65 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2767 55.0574H38.3079V45.0313H48.334V33.0001H38.3079V22.974H26.2767V33.0001H16.2506V45.0313H26.2767V55.0574ZM32.2923 81.1251C23.0015 78.7857 15.3323 73.4545 9.28456 65.1315C3.23418 56.8113 0.208984 47.5713 0.208984 37.4115V12.948L32.2923 0.916748L64.3756 12.948V37.4115C64.3756 47.5713 61.3518 56.8113 55.3041 65.1315C49.2537 73.4545 41.5831 78.7857 32.2923 81.1251ZM32.2923 72.7032C39.2437 70.4975 44.992 66.086 49.5371 59.4688C54.0822 52.8516 56.3548 45.4992 56.3548 37.4115V18.4623L32.2923 9.43888L8.22982 18.4623V37.4115C8.22982 45.4992 10.5024 52.8516 15.0475 59.4688C19.5927 66.086 25.3409 70.4975 32.2923 72.7032V72.7032Z",
    fill: "#2F2D30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyblack);
export default __webpack_public_path__ + "static/media/safetyblack.d067e7e5f63c3fedb09abd171abe820c.svg";
export { ForwardRef as ReactComponent };